import FrequencyBarPlot from "./FrequencyBarPlot.svelte";
export var IntervalBase;
(function (IntervalBase) {
    IntervalBase["MILLIS"] = "millis";
    IntervalBase["SECONDS"] = "seconds";
    IntervalBase["MINUTES"] = "minutes";
    IntervalBase["HOURS"] = "hours";
    IntervalBase["DAYS"] = "days";
    IntervalBase["WEEKS"] = "weeks";
    IntervalBase["MONTHS"] = "months";
    IntervalBase["YEARS"] = "years";
    IntervalBase["DECADES"] = "decades";
    IntervalBase["CENTURIES"] = "centuries";
    IntervalBase["MILLEnNIA"] = "millennia";
    IntervalBase["DECAMILLENNIA"] = "decamillennia";
})(IntervalBase || (IntervalBase = {}));
